import React from 'react';
import { Card } from 'react-bootstrap';
import './News.css';

const getMediaType = (src) => {
  if (!src) return 'image';
  const extension = src.split('.').pop().toLowerCase();
  if (extension === 'mp4') return 'video';
  if (extension === 'gif') return 'gif';
  return 'image';
};

const CardComponent = ({ image, date, title, text, url, alt, photoCredit, topic, credit, onClick }) => {
  const mediaType = getMediaType(image);

  const renderTextContent = (content) => {
    const toBlocks = (text) => {
      const cleaned = String(text ?? '')
        .replace(/\\n/g, '\n')
        .replace(/\/n/g, '\n');
      const lines = cleaned.split(/\r?\n/);
      const blocks = [];
      let list = [];
      for (let i = 0; i < lines.length; i++) {
        const raw = lines[i];
        const line = raw.trim();
        const bullet = /^(-|\*|•)\s+/.test(line) || /^\d+\.\s+/.test(line);
        const headingHash = /^#{1,3}\s+/.test(line);
        const headingColon = !headingHash && /:\s*$/.test(line) && line.length <= 120;
        if (bullet) {
          const item = line
            .replace(/^(-|\*|•)\s+/, '')
            .replace(/^\d+\.\s+/, '');
          if (item.length) list.push(item);
          continue;
        }
        if (list.length) {
          blocks.push({ type: 'list', items: list });
          list = [];
        }
        if (headingHash) {
          const h = line.replace(/^#{1,3}\s+/, '');
          if (h.length) blocks.push({ type: 'heading', text: h });
          continue;
        }
        if (headingColon) {
          const h = line.replace(/:\s*$/, '');
          if (h.length) blocks.push({ type: 'heading', text: h });
          continue;
        }
        if (line.length) {
          blocks.push({ type: 'paragraph', text: line });
        }
      }
      if (list.length) {
        blocks.push({ type: 'list', items: list });
      }
      return blocks;
    };
    const source = Array.isArray(content) ? content : [content];
    const blocks = source.flatMap(toBlocks);
    return blocks.map((b, i) => {
      if (b.type === 'heading') return <h5 key={`h-${i}`} className="mb-2">{b.text}</h5>;
      if (b.type === 'list') return <ul key={`ul-${i}`}>{b.items.map((it, j) => <li key={`li-${i}-${j}`}>{it}</li>)}</ul>;
      return <p key={`p-${i}`}>{b.text}</p>;
    });
  };

  const renderMedia = () => {
    switch (mediaType) {
      case 'video':
        return (
          <video 
            className="card-img-top media-rounded"
            autoPlay 
            loop 
            muted 
            playsInline
          >
            <source src={image} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      case 'gif':
      case 'image':
      default:
        return (
          <Card.Img
            variant="top"
            src={image}
            className="card-img-top media-rounded"
            alt={alt}
          />
        );
    }
  };

  return (
    <Card className="card-hover d-flex flex-column h-100" onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      <div className="aspect-ratio-16-9 media-container">
        {renderMedia()}
      </div>
      <Card.Body className="d-flex flex-column flex-grow-1">
        <table>
          <tbody>
            <tr>
              <td className="card-date">
                <Card.Title className="custom-card-text-left">{date}</Card.Title>
              </td>
              <Card.Title className="custom-card-text-right">{photoCredit}</Card.Title>
            </tr>
          </tbody>
        </table>
        <hr className="custom-card-divider" />
        <Card.Title className="custom-card-title">{title}</Card.Title>
        <hr className="custom-card-divider" />
        <div className="custom-card-text flex-grow-1">
          {renderTextContent(text)}
        </div>
        {url && (
          <Card.Text className="custom-card-text">
            <a href={url} target="_blank" rel="noopener noreferrer">
              {credit ? `${credit} -> Website` : '-> Website'}
            </a>
          </Card.Text>
        )}
      </Card.Body>
      <Card.Footer>
        {topic && <span className="card-topic">{topic}</span>}
      </Card.Footer>
    </Card>
  );
};

export default CardComponent;
